import { render, staticRenderFns } from "./GoldApple.vue?vue&type=template&id=332af370&scoped=true&"
import script from "./GoldApple.vue?vue&type=script&lang=js&"
export * from "./GoldApple.vue?vue&type=script&lang=js&"
import style0 from "./GoldApple.vue?vue&type=style&index=0&id=332af370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332af370",
  null
  
)

export default component.exports